import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Wrapper } from './style';
import { formatMessage } from '../../CurrentLocale';
import Close from '../../assets/images/xmark.svg';
import ArrowRight from '../../assets/images/arrow-right.svg';
import ArrowUpSquare from '../../assets/images/arrow-up-square.svg';

class SearchHelpPopup extends Component<Props, State> {
  bodiesRef = React.createRef();

  state = {
    tab: this.props.activeTab ? this.props.activeTab : 'search'
  };

  tabs = ['search', 'advanced', 'access', 'export', 'subscribe'];

  handleChangeTab = tab => {
    this.setState({ tab }, () => {
      if (this.bodiesRef.current) {
        this.bodiesRef.current.scrollTop = 0;
      }
    });
  };

  render() {
    const { onToggle } = this.props;

    return (
      <Wrapper>
        <div className="help">
          <div className="help__background" onClick={() => onToggle()} />
          <div className="help__modal">
            <div className="help__modal__header">
              <h3 className="help__modal__header__title">
                {formatMessage({ id: 'advancedSearch.search_help' })}
              </h3>
              <button
                className="help__modal__header__close"
                type="button"
                onClick={() => onToggle()}
              >
                <img
                  className="help__modal__header__close__img"
                  src={Close}
                  alt="Close the popup"
                />
              </button>
            </div>
            <div className="help__modal__tabs">
              {this.tabs.map((tab, i) => (
                <button
                  key={i}
                  className={`help__modal__tabs__item ${
                    tab === this.state.tab
                      ? 'help__modal__tabs__item--active'
                      : ''
                  }`}
                  type="button"
                  onClick={() => this.handleChangeTab(tab)}
                >
                  {formatMessage({ id: `helpPopup.tab.${tab}` })}
                </button>
              ))}
            </div>
            <div className="help__modal__bodies" ref={this.bodiesRef}>
              {this.tabs.map((tab, i) => (
                <div
                  key={i}
                  className={`help__modal__bodies__item ${
                    tab === this.state.tab
                      ? 'help__modal__bodies__item--active'
                      : ''
                  }`}
                  dangerouslySetInnerHTML={{
                    __html: formatMessage({ id: `helpPopup.body.${tab}` })
                  }}
                />
              ))}
            </div>
            <div className="help__modal__buttons">
              <button
                className="help__modal__buttons__button"
                type="button"
                onClick={() => onToggle()}
              >
                {formatMessage({ id: 'helpPopup.continue_my_search' })}
                <img
                  className="help__modal__buttons__button__img"
                  src={ArrowRight}
                  alt="Continue my search"
                />
              </button>
              <a
                className="help__modal__buttons__button"
                href="https://documentation-openedition-org.ezscd.univ-lyon3.fr/docs/search-openedition/"
                target="_blank"
                onClick={() => onToggle()}
              >
                {formatMessage({ id: 'helpPopup.get_more_information' })}
                <img
                  className="help__modal__buttons__button__img"
                  src={ArrowUpSquare}
                  alt="Get more information"
                />
              </a>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default SearchHelpPopup;



// WEBPACK FOOTER //
// ./src/components/SearchHelpPopup/index.js